import { publicInstance } from "../config/axios"

export const getEducationalVideo = async (uuid) => {
  const response = await publicInstance.get(`/educational-videos/${uuid}`)
  return response.data
}
